import React, { useState } from "react";
import "./Navbar.css";
import logoImg from "../assets/logo.png";
import menuImg from "../assets/menu-white.png";

const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <nav className="navbar">
      {/* LOGO */}
      <div className="logo">
        <img src={logoImg} alt="Aradhana" className="logo-img" />
      </div>

      {/* NAV LINKS (desktop) */}
      <ul className="nav-links">
        <li>
          <a href="#home">Home</a>
        </li>
        <li>
          <a href="#projects">Projects</a>
        </li>
        <li>
          <a href="#about">About</a>
        </li>
        <li>
          <a href="#gallery">Gallery</a>
        </li>
        <li>
          <a href="#contact" className="contact-btn">
            Contact
          </a>
        </li>
      </ul>

      {/* HAMBURGER (mobile) */}
      <button className="hamburger" onClick={() => setOpen((v) => !v)} aria-label="Menu">
        <img src={menuImg} alt="menu" />
      </button>

      {/* MOBILE MENU */}
      {open && (
        <div className="mobile-menu">
          <ul>
            <li onClick={() => setOpen(false)}>
              <a href="#home">Home</a>
            </li>
            <li onClick={() => setOpen(false)}>
              <a href="#projects">Projects</a>
            </li>
            <li onClick={() => setOpen(false)}>
              <a href="#about">About</a>
            </li>
            <li onClick={() => setOpen(false)}>
              <a href="#gallery">Gallery</a>
            </li>
            <li onClick={() => setOpen(false)}>
              <a href="#contact" className="contact-btn">
                Contact
              </a>
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
